import { ImagePlus, Video, Sparkles, Lock } from "lucide-react";
import { motion } from "framer-motion";

export default function ComposeCard({
    community,
    hasAccess = true,
    user,
    onCompose,
    onUnlock
}) {

    return (

        <motion.div

            initial={{ opacity:0, y:20 }}

            animate={{ opacity:1, y:0 }}

            className="
                rounded-[32px]
                bg-white/70
                backdrop-blur-xl
                border
                border-white/30
                shadow-xl
                overflow-hidden
            "

        >

            {/* Header */}

            <div className="flex items-center gap-4 p-6">

                <img

                    src={
                        user?.avatar ??
                        "https://ui-avatars.com/api/?name=User"
                    }

                    className="
                        w-14
                        h-14
                        rounded-full
                        object-cover
                    "

                    alt=""

                />

                <div>

                    <div className="font-semibold text-lg">

                        {user?.name ?? "Creator"}

                    </div>

                    <div className="text-gray-500 text-sm">

                        Share something with {community.shortTitle}

                    </div>

                </div>

            </div>

            {/* Body */}

            {

                hasAccess ?

                (

                    <>

                        <button

                            onClick={onCompose}

                            className="
                                mx-6
                                mb-6
                                w-[calc(100%-3rem)]
                                rounded-full
                                bg-gray-100
                                hover:bg-gray-200
                                transition
                                px-6
                                py-5
                                text-left
                                text-gray-500
                            "

                        >

                            ✨ What's inspiring you today...

                        </button>

                        {/* Actions */}

                        <div
                            className="
                                border-t
                                border-gray-100
                                px-6
                                py-5
                                flex
                                justify-between
                                flex-wrap
                                gap-4
                            "
                        >

                            <ActionButton

                                icon={<ImagePlus size={18}/>}

                                label="Photo"

                                onClick={onCompose}

                            />

                            <ActionButton

                                icon={<Video size={18}/>}

                                label="Video"

                                onClick={onCompose}

                            />

                            <ActionButton

                                icon={<Sparkles size={18}/>}

                                label="Idea"

                                onClick={onCompose}

                            />

                            <button

                                onClick={onCompose}

                                className={`
                                    px-6
                                    py-3
                                    rounded-full
                                    text-white
                                    font-semibold
                                    ${community.button}
                                `}

                            >

                                Create Thread

                            </button>

                        </div>

                    </>

                )

                :

                (

                    <div className="p-8">

                        <div
                            className="
                                rounded-3xl
                                bg-gradient-to-r
                                from-orange-50
                                to-yellow-50
                                border
                                border-orange-200
                                p-8
                                text-center
                            "
                        >

                            <Lock
                                size={42}
                                className="
                                    mx-auto
                                    text-orange-500
                                "
                            />

                            <h3
                                className="
                                    mt-5
                                    text-2xl
                                    font-bold
                                "
                            >

                                Community Locked

                            </h3>

                            <p
                                className="
                                    mt-3
                                    text-gray-600
                                    leading-7
                                "
                            >

                                Purchase a product from

                                {" "}

                                <strong>

                                    {community.title}

                                </strong>

                                {" "}

                                collection to unlock posting,
                                comments and discussions.

                            </p>

                            <button

                                onClick={onUnlock}

                                className={`
                                    mt-8
                                    px-8
                                    py-4
                                    rounded-full
                                    text-white
                                    font-semibold
                                    ${community.button}
                                `}

                            >

                                Unlock Community

                            </button>

                        </div>

                    </div>

                )

            }

        </motion.div>

    );

}

function ActionButton({

    icon,

    label,

    onClick

}){

    return(

        <button

            onClick={onClick}

            className="
                flex
                items-center
                gap-2
                text-gray-600
                hover:text-gray-900
                transition
            "

        >

            {icon}

            {label}

        </button>

    );

}